import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {CoreComponent} from "../../../../core/component/core-component/core.component";
import {ContractsRuntimeDto, ContractsRuntimeInsuranceDto, ContractStatusEnum} from "../../types/contracts.types";
import {Router} from "@angular/router";
import {TableRowSelectEvent} from "primeng/table";


@Component({
  selector: 'app-contracts',
  templateUrl: './contracts.component.html',
  styleUrls: ['contracts.component.scss']
})
export class ContractsComponent extends CoreComponent implements OnInit {

  @Input() contractsRuntime!: ContractsRuntimeDto;
  @Input() source?: string;
  @Input() showUnmanaged: boolean = false;
  @Input() showActiveOnly: boolean = false;
  @Input() header: string = 'Aktive Verträge';
  @Input() showTooltip: boolean = false;
  @Input() tooltipText: string = '';
  uiContracts: ContractsRuntimeInsuranceDto[] = [];

  constructor(protected router: Router) {
    super();
  }

  override ngOnInit() {
    super.ngOnInit();

    this.refreshComponent();
  }


  refreshComponent() {
    if (!this.contractsRuntime.contracts || !this.contractsRuntime.contracts.length) {
      return;
    }

    if (this.showActiveOnly) {
      // Ticket: DEF1000000956
      this.uiContracts = this.contractsRuntime.contracts?.filter(item => (item.contractStatus == ContractStatusEnum.active && item.notFullyManaged == this.showUnmanaged));
    } else if (this.showUnmanaged) {
      this.uiContracts = this.contractsRuntime.contracts?.filter(item => item.notFullyManaged == true);
    } else {
      this.uiContracts = this.contractsRuntime.contracts?.filter(item => item.notFullyManaged == false);
    }

    this.initialized = true;
  }

  handleContractTableRowSelect(event: TableRowSelectEvent) {

  }

  showContract(contract: ContractsRuntimeInsuranceDto) {

    this.router.navigate(['/ds/contract', contract.id, this.source]);

  }

  showAllContracts() {

    this.router.navigate(['/ds/contracts']);
  }


}
